import MainLayout from '../../components/Layout/MainLayout'
import { Button, Table, Modal, Empty, Spin } from 'antd'
import { withNamespaces } from 'react-i18next'
import { useEffect, useState } from 'react'
import CashRequestService from '../../services/cashRequest.service'
import { PlusOutlined } from '@ant-design/icons'
import CreateRequestCash from './CreateRequest'
import AddressServices from '../../services/address.service'
import { LocalStore } from '../../utils/LocalStore'
import { moneyFormat } from '../../utils/stringUtils'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { getUrlQueryString } from '../../utils/helper'
import { parseQueryStringToObject } from '../../utils/stringUtils'

const ListCashRequest = props => {
    const { history } = props
    const currentUser = LocalStore.getInstance().read('currentLoggedUser') || {}
    const [metadata, setMetadata] = useState(0)

    const [page, setPage] = useState(1)
    const [pageSize] = useState(20)
    const [loading, setLoading] = useState(false)
    const [listCashRequest, setListCashRequest] = useState([])
    const [isOpenCreate, setIsOpenCreate] = useState(false)
    const [listAddress, setListAddress] = useState([])
    const [loadingAddress, setLoadingAddress] = useState(false)

    useEffect(() => {
        const currentProjectInfo = LocalStore.getInstance().read('currentProjectInfo') || {}
        const tenantConfig = currentProjectInfo.tenantConfig || {}
        const generalConfig = tenantConfig ? tenantConfig.generalConfig : {}
        if (!generalConfig?.enableCashCollectionRequest) {
            history.push({
                pathname: '/',
            })
        }
    }, [history])

    useEffect(() => {
        const queryString = getUrlQueryString()
        const queryObj = parseQueryStringToObject(queryString) || {}
        if (queryObj?.amount) {
            setIsOpenCreate(true)
        }
    }, [])

    const callListCashRequest = (page, size) => {
        console.log('run')
        setLoading(true)
        CashRequestService.getCashList(page - 1, size, (err, res, headers) => {
            console.log('res', res)
            if (!isEmpty(res?.data)) {
                console.log('data', res?.data)
                setListCashRequest(res?.data)
                setLoading(false)
            } else {
                setListCashRequest([])
                setLoading(false)
            }
        })
        setLoading(false)
    }

    const callHeaderCashRequest = (page, size) => {
        CashRequestService.getCashListHeader(page - 1, size, (err, res, headers) => {
            if (!isEmpty(headers)) {
                setMetadata(Number(headers['x-count']))
            }
        })
    }

    const getListAddresses = () => {
        setLoadingAddress(true)
        let queryString = `?page=0&size=10000&sort=defaultAddress:desc,createdAt:desc`
        AddressServices.getListAddressesUser(currentUser.username, queryString, (err, res, headers) => {
            if (!err && res) {
                setListAddress(res)
            } else {
                setListAddress([])
            }
            setLoadingAddress(false)
        })
    }

    useEffect(() => {
        getListAddresses()
        callListCashRequest(page, pageSize)
        callHeaderCashRequest(page, pageSize)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const renderStatusRequest = status => {
        switch (status) {
            case 'TODO':
                return 'Mới'
            case 'CANCELLED':
                return 'Đã hủy'
            case 'DONE':
                return 'Hoàn thành'
            default:
                return status
        }
    }

    const handleCancel = record => {
        Modal.confirm({
            maskClosable: true,
            icon: null,
            title: 'Xác nhận hủy yêu cầu thu tiền mặt?',
            okText: 'Xác nhận',
            cancelText: 'Hủy',
            onOk: () => {
                CashRequestService.cancelCashRequest(record?.id, (error, response) => {
                    if (!isEmpty(response)) {
                        callListCashRequest(page, pageSize)
                        callHeaderCashRequest(page, pageSize)
                    }
                    console.log('res', response)
                })
            },
        })
    }
    const columns = [
        {
            title: 'Số tiền',
            dataIndex: 'customField01',
            key: 'customField01',
            className: 'whitespace',
            render: customField01 => moneyFormat(customField01),
        },
        {
            title: 'Địa chỉ',
            dataIndex: 'customField03',
            key: 'customField03',
            className: 'whitespace',
        },
        {
            title: 'Thời gian lấy',
            dataIndex: 'start',
            key: 'start',
            className: 'whitespace',
            render: start => (start ? moment(start).format('DD/MM/YYYY HH:mm:ss') : ''),
        },
        {
            title: 'Ghi chú',
            dataIndex: 'notes',
            key: 'notes',
            className: 'whitespace',
            width: 250,
            render: notes => <div className="max-w-[250px] whitespace-normal">{notes[0]}</div>,
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            align: 'right',
            key: 'status',
            className: 'whitespace',
            render: status => renderStatusRequest(status),
        },
        {
            title: '',
            dataIndex: 'action',
            align: 'right',
            key: 'action',
            className: 'whitespace',
            render: (action, record) =>
                record?.status === 'TODO' ? (
                    <div
                        onClick={() => handleCancel(record)}
                        className="text-blue-100 cursor-pointer"
                    >
                        Hủy yêu cầu
                    </div>
                ) : (
                    ''
                ),
        },
    ]
    return (
        <MainLayout
            {...props}
            headerTitle={'Yêu cầu thu tiền mặt'}
            title={'Yêu cầu thu tiền mặt'}
        >
            <Spin spinning={loading}>
                <div className={'container-common pdbt30 mgr20 space-y-4'}>
                    <div className="flex justify-end">
                        <Button
                            onClick={() => setIsOpenCreate(true)}
                            type="primary"
                            icon={<PlusOutlined />}
                        >
                            Thêm yêu cầu thu tiền mặt
                        </Button>
                    </div>
                    {!isEmpty(listCashRequest) ? (
                        <Table
                            loading={loading}
                            className={'_table-data custom-empty table-expand-row'}
                            rowKey={'id'}
                            columns={columns}
                            dataSource={listCashRequest}
                            rowClassName={() => `_table-row`}
                            pagination={{
                                className: '_pagination text-center width-100-percent mgt20',
                                hideOnSinglePage: true,
                                current: page,
                                total: metadata,
                                pageSize: pageSize,
                                onChange: newPage => {
                                    callListCashRequest(newPage, pageSize)
                                    callHeaderCashRequest(page, pageSize)

                                    setPage(newPage)
                                },
                            }}
                        />
                    ) : (
                        <Empty description="Không có dữ liệu" />
                    )}
                </div>
            </Spin>
            {isOpenCreate && (
                <CreateRequestCash
                    listAddress={listAddress}
                    currentUser={currentUser}
                    isOpen={isOpenCreate}
                    onClose={() => {
                        setIsOpenCreate(false)
                        callListCashRequest(page, pageSize)
                        callHeaderCashRequest(page, pageSize)
                    }}
                    history={history}
                    loadingAddress={loadingAddress}
                />
            )}
        </MainLayout>
    )
}
export default withNamespaces()(ListCashRequest)
